<template>
  <span class="provider-name">{{ humanName }}</span>
</template>

<script>
export default {
  name: 'provider-name',
  props: {
    name: {
      type: String,
      required: true,
    },
  },
  computed: {
    humanName() {
      return this.$t(`providers.${this.name}`);
    },
  },
};
</script>



// WEBPACK FOOTER //
// ProviderName.vue?34449fa9